export default "__VITE_ASSET__ae2f8276__"